module.exports = __webpack_public_path__ + "img/portugal-colorectal-cancer-male.373de316.png";